module.exports = __webpack_public_path__ + "img/no 21.fdd360ce.png";